/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_age_group = /** @type {(inputs: {}) => string} */ () => {
	return `Věk`
};

const da_attributes_age_group = /** @type {(inputs: {}) => string} */ () => {
	return `Aldersgruppe`
};

const de_attributes_age_group = /** @type {(inputs: {}) => string} */ () => {
	return `Altersgruppe`
};

const en_attributes_age_group = /** @type {(inputs: {}) => string} */ () => {
	return `Age group`
};

const es_attributes_age_group = /** @type {(inputs: {}) => string} */ () => {
	return `Edad`
};

const fr_attributes_age_group = /** @type {(inputs: {}) => string} */ () => {
	return `Age`
};

const hu_attributes_age_group = /** @type {(inputs: {}) => string} */ () => {
	return `Korcsoport`
};

const it_attributes_age_group = /** @type {(inputs: {}) => string} */ () => {
	return `Fascia d'età`
};

const nl_attributes_age_group = /** @type {(inputs: {}) => string} */ () => {
	return `Leeftijdsgroep`
};

const pl_attributes_age_group = /** @type {(inputs: {}) => string} */ () => {
	return `Grupa wiekowa`
};

const pt_attributes_age_group = /** @type {(inputs: {}) => string} */ () => {
	return `Grupo etário`
};

const sv_attributes_age_group = /** @type {(inputs: {}) => string} */ () => {
	return `Åldersgrupp`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_age_group = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_age_group(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_age_group", locale)
	if (locale === "cs") return cs_attributes_age_group(inputs)
	if (locale === "da") return da_attributes_age_group(inputs)
	if (locale === "de") return de_attributes_age_group(inputs)
	if (locale === "en") return en_attributes_age_group(inputs)
	if (locale === "es") return es_attributes_age_group(inputs)
	if (locale === "fr") return fr_attributes_age_group(inputs)
	if (locale === "hu") return hu_attributes_age_group(inputs)
	if (locale === "it") return it_attributes_age_group(inputs)
	if (locale === "nl") return nl_attributes_age_group(inputs)
	if (locale === "pl") return pl_attributes_age_group(inputs)
	if (locale === "pt") return pt_attributes_age_group(inputs)
	return sv_attributes_age_group(inputs)
};
export { attributes_age_group as "attributes.age_group" }